
<script>

export default {
   
}
</script>

<template>
    <div>
        <div class="fs-3 fw-bold">Consent</div>
        <p>
            I/we, the taxpayer, have read the above
            information.
        </p>
        <p>
            I/we hereby consent to the disclosure of tax
            return information described in the Global
            Carry Forward terms above and allow the tax
            return preparer to enter a PIN in the tax
            preparation software on my behalf to verify
            that I/we consent to the terms of this
            disclosure.
        </p>
        <div class="row px-3">
            <div
                class="col-12 col-lg-10 border border-primary p-2"
            >
                <div
                    class="d-flex align-items-start gap-2"
                >
                    <div
                        class="d-flex flex-column gap-1"
                    >
                        <div>
                            Primary taxpayer printed
                            name
                        </div>
                        <div>
                            <input
                                class="form-control check_field"
                                type="text"
                                name="primaryTaxPayerName"
                            />
                        </div>
                    </div>
                    <div
                        class="d-flex flex-column gap-1"
                    >
                        <div>
                            I authorize my Tax Preparer
                            to enter the five number PIN
                            I have choosen below.
                        </div>
                        <div>
                            <input
                                class="form-control check_field"
                                type="number"
                                name="firstTaxPayerPin"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="col-12 col-lg-2 border border-primary p-2"
            >
                <div class="d-flex flex-column gap-1">
                    <div>Date</div>
                    <div>
                        <input
                            type="date"
                            class="form-control check_field"
                            value=""
                            name="firstTaxPayerDate"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-2 px-3">
            <div
                class="col-12 col-lg-10 border border-primary p-2"
            >
                <div
                    class="d-flex align-items-start gap-2"
                >
                    <div
                        class="d-flex flex-column gap-1"
                    >
                        <div>
                            Secondary taxpayer printed
                            name
                        </div>
                        <div>
                            <input
                                class="form-control check_field"
                                type="text"
                                name="secondTaxPayerName"
                            />
                        </div>
                    </div>
                    <div
                        class="d-flex flex-column gap-1"
                    >
                        <div>
                            I authorize my Tax Preparer
                            to enter the five number PIN
                            I have choosen below.
                        </div>
                        <div>
                            <input
                                class="form-control check_field"
                                type="number"
                                name="secondTaxPayerPin"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="col-12 col-lg-2 border border-primary p-2"
            >
                <div class="d-flex flex-column gap-1">
                    <div>Date</div>
                    <div>
                        <input
                            type="date"
                            class="form-control check_field"
                            value=""
                            name="secondTaxPayerDate"
                        />
                    </div>
                </div>
            </div>
        </div>
        <p>
            If you believe your tax return information
            has been disclosed or used improperly in a
            manner unauthorized by law or without your
            permission, you may contact the Treasury
            Inspector General for Tax Administration
            (TIGTA) by telephone at 1-800-366-4484, or
            by e-mail at complaints@tigta.treas.gov.
        </p>
    </div>
</template>